import { Flex, Pagination, Select } from 'antd';
import NextIcon from '../assets/icons/NextIcon';
import PrevIcon from '../assets/icons/PrevIcon';
import { cn, searchInLabel, selectStringOption } from '../utils/global.utils';

interface CustomPaginationProps {
  limit: number;
  total: number;
  page?: number;
  hidePagination?: boolean;
  hidePage?: boolean;
  className?: string;
  handlePagination?: (paginationPage: number, paginationLimit: number) => void;
}

export default function CustomPagination({
  limit,
  total,
  page,
  hidePagination,
  hidePage,
  className = '',
  handlePagination,
}: CustomPaginationProps) {
  if (!hidePagination && total && limit)
    return (
      <Flex
        gap={8}
        wrap={true}
        align="center"
        justify={hidePage ? 'center' : 'space-between'}
        className={cn('custom-pagination px-4 py-2.5', className)}
      >
        {!hidePage && (
          <Flex
            align="center"
            gap={8}
            className="text-sm text-theme-gray-40 font-medium"
          >
            <span>Page</span>
            <span>
              <Select
                size="small"
                style={{ minWidth: 75, textAlign: 'center' }}
                value={page}
                onChange={(val) =>
                  handlePagination && handlePagination(val, limit)
                }
                filterOption={searchInLabel}
                options={selectStringOption(
                  [...Array(Math.ceil(total / limit))].map(
                    (_, index) => `${index + 1}`,
                  ),
                  'number',
                )}
              />
            </span>
            <span>of {Math.ceil(total / limit)}</span>
          </Flex>
        )}

        {/* Ant Design Pagination */}
        <Pagination
          total={total}
          current={page}
          pageSize={limit}
          showSizeChanger={false}
          onChange={handlePagination}
          itemRender={(_, type, __) => {
            if (type === 'prev') return <PrevIcon />;
            if (type === 'next') return <NextIcon />;
            return __;
          }}
        />
      </Flex>
    );

  return null;
}
